import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { getRoundedStarRating } from "utils/rating";
import { Text } from "components/core/Typography";
import Star from "./Star";

import "./StarRating.scss";

function formatRating(rating) {
	return Number.isInteger(rating) ? `${rating}.0` : rating;
}

function StarRating({ className, outOf = 5, rating = 0, withLabel = false }) {
	return (
		<div className={classnames(className, "star-rating")}>
			<span>
				{Array(outOf)
					.fill(0)
					.map((_, i) => (
						<Star
							key={`star-rating-${rating - i}`}
							value={getRoundedStarRating(rating - i)}
							color="#1C72E74D"
						/>
					))}
			</span>
			{withLabel && (
				<Text
					last
					size="small"
					color="blue"
					weight="extraBold"
				>
					{formatRating(rating)}
				</Text>
			)}
		</div>
	);
}

StarRating.propTypes = {
	className: PropTypes.string,
	outOf: PropTypes.number,
	rating: PropTypes.number,
	withLabel: PropTypes.bool
};

export default StarRating;
